import { render } from "./ModernFooter.vue?vue&type=template&id=316b5cf8&scoped=true"
import script from "./ModernFooter.vue?vue&type=script&lang=js"
export * from "./ModernFooter.vue?vue&type=script&lang=js"

import "./ModernFooter.vue?vue&type=style&index=0&id=316b5cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316b5cf8"]])

export default __exports__